<template>
  <div id="dashboard">
    <dashboard-filters-view
      :value="filters"
      :onChange="onChangeFilters"
      :clear="clearFilters"
    />
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <b-card
          style="min-height: 182px;"
          class="card-congratulation-medal"
        >
          <h5> En este transcurso
            <br>
            de tiempo han realizado
          </h5>
          <h3 class="mb-75 mt-5 pt-50">
            {{dashboardResume.total}} procesos
            <br>
            de aprobaciones
          </h3>
          <b-img
            :src="require('@/assets/images/badge.svg')"
            class="congratulation-medal"
            alt="Medal Pic"
          />
        </b-card>
      </div>
      <div class="col-lg-8 col-md-6" v-if="!loading">
        <dashboard-indicators :indicators="dashboardApprovalsIndicators" />
      </div>
    </div>
    <dashboard-resume v-if="!loading" :resume="dashboardResume"/>
    <div class="row" id="details">
      <div class="col-12 mb-3">
        <h4 class="text-primary">
          Flujos en curso pendientes de aprobación ({{dashboardResume.enCurso}})
        </h4>
        <small>
          Selecciona una aprobación del listado para ver su detalle
        </small>
      </div>
      <div class="col-8" v-if="!loading">
       <table-dashboard-approvals
         :approvals="dashboardApprovalsList"
         @select="selectFlow"
       />
      </div>
      <div class="col-4" v-if="!loading">
        <dashboard-detail-flow :flow="detailsFlow" :approvalFlow="dashboardApprovalFlow" />
      </div>
    </div>
    <div class="position-fixed download text-left m-auto" v-if="!loading">
      <div>
        <b-button
          class="badge-glow"
          variant="warning"
          @click="downloadData"
        >
          <feather-icon
            icon="DownloadIcon"
            class="mr-50"
          />
          <span class="align-middle">Descargar</span>
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import TableDashboardApprovals from '@/febos/chile/approvals/vistas/dashboard/TableDashboardApprovals';
import DashboardIndicators from '@/febos/chile/approvals/vistas/dashboard/DashboardIndicators';
import DashboardResume from '@/febos/chile/approvals/vistas/dashboard/DashboardResume';
import DashboardDetailFlow from '@/febos/chile/approvals/vistas/dashboard/DashboardDetailFlow';
import DashboardFiltersView from '@/febos/chile/approvals/vistas/dashboard/filters/DashboardFiltersView';

export default {
  components: {
    TableDashboardApprovals,
    DashboardIndicators,
    DashboardResume,
    DashboardDetailFlow,
    DashboardFiltersView
  },
  data() {
    return {
      filters: '',
      searchParam: false,
      detailsFlow: {}
    };
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#dashboard > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#dashboard',
        scale: 0.6
      });
    },
    dashboardApprovalFlowLoading(value) {
      if (!value) {
        this.$vs.loading.close('#details > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#details',
        scale: 0.6
      });
    },
    successAction() {
      this.$vs.notify({
        title: 'Genial!',
        text: 'Acción realizada exitosamente',
        color: 'success',
        time: 3000,
        position: 'top-center'
      });
    },
    error(error) {
      if (error !== '') {
        this.$bvToast.toast(
          `${error}`,
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        this.clearErrorMessage();
      }
    }
  },
  computed: {
    ...mapGetters('Approvals', [
      'loading',
      'error',
      'dashboardApprovals',
      'dashboardResume',
      'dashboardApprovalsList',
      'dashboardApprovalsIndicators',
      'dashboardApprovalFlow',
      'dashboardApprovalFlowLoading'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
  },
  methods: {
    ...mapActions('Approvals', [
      'getApprovalsDashboard',
      'clearErrorMessage',
      'getApprovalDashboardFlow',
      'getCsvApprovalsDashboard'
    ]),
    downloadData() {
      this.getCsvApprovalsDashboard({
        filtros: this.filters.concat(`|ej.iutEmpresa:${this.company.id}`),
        reporte: 'si'
      });
    },
    selectFlow(flow) {
      this.detailsFlow = flow;
      this.getApprovalDashboardFlow({
        aprobacionId: flow.id,
        ejecucionId: flow.id,
        retornarPdf: 'no'
      });
    },
    async onChangeFilters(filters, onMounted) {
      this.filters = filters;
      if (!onMounted) {
        await this.getDashboard(filters);
      }
    },
    clearFilters() {
      // TODO: try to change to default filter state for current view.
      this.$router.go();
    },
    getDashboard(filters) {
      const filtersApply = filters !== ''
        ? filters.concat(`|ej.iutEmpresa:${this.company.id}`)
        : `|ej.iutEmpresa:${this.company.id}`;
      this.getApprovalsDashboard({
        filtros: filtersApply,
        resumen: 'si'
      });
      if (this.dashboardApprovalsList.length) {
        this.selectFlow(this.dashboardApprovalsList[0]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/@core/scss/vue/pages/dashboard-ecommerce.scss';
.container-stats {
  display: flex;
}

.stats {
  flex: 1; /* additionally, equal width */
  flex-direction: column
}

.download {
  bottom: 40px;
  right: 20px;
}

</style>
